import React, { PureComponent } from 'react';
import mergeClassNames from 'classnames';

class Pagination extends PureComponent {
    render() {
        const {
            children,
            ...props
        } = this.props;

        const classNames = mergeClassNames({
            ['d-flex']: true,
            ['flex-row']: true
        });

        return (
            <div className={classNames} {...props}>
                {children}
            </div>
        );
    }
}

Pagination.defaultProps = {};

export default Pagination;
